export default __webpack_public_path__ + "static/media/skoda.00a01427.svg";